import { ComponentProps, FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TextInput } from '@telialt/common-text-input/src';

import { PHONE_VALIDATION_INTERNATIONAL_PATTERN, PHONE_VALIDATION_PATTERN } from './constants';

type Props = { isInternationalOnly?: boolean } & Omit<ComponentProps<typeof TextInput>, 'type' | 'inputMode'>;

export const PhoneInput: FC<Props> = ({ isInternationalOnly, ...props }) => {
    const { t } = useTranslations();

    return (
        <TextInput
            type="tel"
            inputMode="tel"
            pattern={isInternationalOnly ? PHONE_VALIDATION_INTERNATIONAL_PATTERN : PHONE_VALIDATION_PATTERN}
            patternErrorMessage={
                isInternationalOnly
                    ? t['common.phone_input.pattern_international_error']
                    : t['common.phone_input.pattern_error']
            }
            requiredErrorMessage={
                isInternationalOnly
                    ? t['common.phone_input.pattern_international_error']
                    : t['common.phone_input.pattern_error']
            }
            {...props}
        />
    );
};
